export const degreeDaysInsectIds = [
  1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 23, 24, 25, 26, 27, 28, 29, 30,
] as const

export const trapCatchesInsectIds = [
  1, 2, 6, 7, 9, 10, 11, 12, 15, 16, 17, 19, 20, 25, 27, 28, 29, 30,
] as const

export const larvalTrendInsectIds = [1, 3, 6, 7, 9, 11, 20] as const

export const phenologyInsectIds = [1, 7, 11] as const

export type TDegreeDaysInsectId = (typeof degreeDaysInsectIds)[number]
